const getServiceOrderByIDReportUsecase = (repository) => async (id) => {
    return await repository(id);
}

export default getServiceOrderByIDReportUsecase;